module.exports = __webpack_public_path__ + "img/profile-1.1f56b865.png";